import { useRouter } from "next/router";
import { Card, Button, Stack } from "@shopify/polaris";
import React from "react";

function UpgradeCardSectionLarge({ plan = {} }) {
    const router = useRouter();
    return (
        <Card.Section>
            <Stack
                alignment="center"
                vertical={true}
                distribution="equalSpacing"
            >
                <Stack.Item>
                    This feature requires you to upgrade to{" "}
                    <strong>{plan.title}</strong> plan in order to use.
                </Stack.Item>
                <div style={{ marginTop: "10px", marginBottom: "10px" }}>
                    <Button
                        primary
                        onClick={() => {
                            router.push(
                                "/settings/pricing",
                                "/settings/pricing",
                                {
                                    shallow: true,
                                },
                            );
                        }}
                    >
                        Upgrade to {plan.title} plan
                    </Button>
                </div>
            </Stack>
        </Card.Section>
    );
}

export default UpgradeCardSectionLarge;
